import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { Filter, Main } from 'Containers/';
import { INGREDIENT_LISTING_REPORT_FORM_NAME } from 'Common/FormEnum';
import { withReportSubscription } from 'State/report/withReportSubscription';
import { IngredientListingFieldEnum as Fields } from 'Common/FieldEnum';
import * as PagingSelectors from 'State/paging/selectors';
import * as PagingConstants from 'State/paging/constants';

import { IngredientListingForm } from './components/IngredientListingForm';

const INITIAL_VALUES = {
  [Fields.IngredientIds]: [],
  [Fields.BaseWeightType]: 0,
  [Fields.SortBy]: 'CN_Code',
  [Fields.All]: false,
};

function IngredientListingReportContainer({
  getReport,
  reportFetching,
  paginationParameters,
  searchParameters,
}) {
  const handleSubmit = (values) => {
    const data = {
      ...values,
      [Fields.SearchParam]: {
        ...searchParameters,
        ...paginationParameters,
        [Fields.All]: values[Fields.All],
      },
    };
    getReport('reports/IngredientListing', data);
  };

  const mainProps = () => ({
    toolbox: {
      formName: INGREDIENT_LISTING_REPORT_FORM_NAME,
      saveButtonProps: {
        content: 'View',
        loading: reportFetching,
        disabled: reportFetching,
      },
      shown: true,
    },
  });

  return (
    <Fragment>
      <Filter title={'Ingredient Listing Report'} />
      <Main {...mainProps()}>
        <IngredientListingForm
          onSubmit={handleSubmit}
          initialValues={INITIAL_VALUES}
          loading={reportFetching}
        />
      </Main>
    </Fragment>
  );
}

const mapState = (state) => {
  const primaryPagingSelectors = PagingSelectors.commonStatePagingSelectors(
    PagingConstants.primaryStateName
  );

  return {
    paginationParameters: primaryPagingSelectors.getPaginationParameters(state),
    searchParameters: primaryPagingSelectors.getSearchParameters(state),
  };
};

export const IngredientListing = withReportSubscription(
  connect(mapState)(IngredientListingReportContainer)
);
IngredientListing.path = '/ingredientlisting';



// WEBPACK FOOTER //
// ./src/pages/ingredientlisting/IngredientListing.js